import React from 'react';
import {Card, DataTable} from './primitives';
import type {OhdBloodPressureBreakdown} from '../types';

interface Props {
    bp: OhdBloodPressureBreakdown;
}

const CATEGORIES: Array<{category: string; systolic: string; diastolic: string; key: keyof Omit<OhdBloodPressureBreakdown, 'total'>}> = [
    {category: 'Normal', systolic: 'Less than 121', diastolic: 'Less than 81', key: 'normal'},
    {category: 'Elevated', systolic: '121-129', diastolic: 'Less than 81', key: 'elevated'},
    {category: 'High BP Stage 1', systolic: '130-139', diastolic: '80-89', key: 'high_stage_1'},
    {category: 'High BP Stage 2', systolic: '140 or higher', diastolic: '90 or higher', key: 'high_stage_2'},
    {category: 'Hypertensive Crisis', systolic: '180 or higher', diastolic: '120 or higher', key: 'hypertensive_crisis'},
];

const BloodPressureTable: React.FC<Props> = ({bp}) => {
    const rows = CATEGORIES.map((c) => [c.category, c.systolic, c.diastolic, bp[c.key].toLocaleString()]);
    return (
        <div>
            <h2 className="mb-2 text-[24px] text-mld-muted-text">Blood Pressure</h2>
            <Card>
                <div className="p-5">
                    <DataTable headers={['Category', 'Systolic', 'Diastolic', 'Total']} rows={rows} />
                </div>
            </Card>
        </div>
    );
};

export default BloodPressureTable;
